// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  padding: 0 !important;
  margin: 0 !important;
}

.modal-100w {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  max-width: inherit !important;
  height: 100% !important;
}

.modal-header {
  border-bottom: 0px !important;
}

.modal-dialog {
  max-width: none;
}

.modal-100w .modal-content {
  border: 0;
  border-radius: 0;
  min-height: -webkit-fill-available;
  background-color: rgba(255, 255, 255, 0.9294117647) !important;
}

.img-wrapper {
  height: calc(100% - 100px) !important;
  overflow: hidden;
  width: max-content;
  margin: 0 10%;
}

.img-cont {
  float: left;
  margin: 15px;
  /*height: calc(100% - 15px);
  display: inline-grid;*/
  width: 70vw;
}

.img-show {
  height: calc(100% - 100px) !important;
  overflow: hidden;
  width: 70vw;
  margin: 0 10%;
  position: absolute;
  top: 0;
}

.back_btn {
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 26px;
  float: left;
  cursor: pointer;
}

.gal_title {
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 46px;
  text-align: center;
  padding: 3% 0 0 0;
}

.gal_subtitle {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}

.modal-title {
  width: 100% !important;
}

.title_ctr {
  width: 100%;
}

.img-cont img {
  max-height: calc(100vh - 200px) !important;
  width: 100%;
  border-radius: 20px;
}

input[type=range] {
  width: 50vw;
  margin: 0 20%;
  height: 2px;
  background: linear-gradient(to right, rgb(185, 166, 145) 0%, rgb(185, 166, 145) 50%, rgb(185, 166, 145) 50%, #fff 100%);
  border: solid 1px rgb(185, 166, 145);
}

input::-webkit-slider-thumb {
  background-color: orange;
  border: solid 12px gold;
  border-radius: 0;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  -webkit-appearance: none;
}

.carousel.carousel-slider .control-arrow {
  cursor: none;
  display: none !important;
}

.carousel .carousel-status {
  display: none !important;
}

.carousel .control-dots {
  display: none !important;
}

@media screen and (max-width: 451px) {
  .Modal .modal .modal-content {
    margin-left: 20px;
    width: 100%;
    margin-right: 20px;
  }
}
@media only screen and (max-width: 768px) {
  .gal_title {
    padding: 7% 10% 0 12% !important;
    font-size: 20px;
  }
  .modal-header {
    padding-bottom: 0px !important;
  }
  .modal-body {
    padding-top: 0px !important;
  }
}
.close_btn {
  right: 10px;
  position: absolute;
  padding: 0px 10px;
  font-size: 16px;
  color: #7a7a7a;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/containers/ChooseAFlight/Gallery/Modal.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,oBAAA;AADF;;AAIA;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,6BAAA;EACA,uBAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAGA;EACE,eAAA;AAAF;;AAEA;EACE,SAAA;EACA,gBAAA;EACA,kCAAA;EACA,8DAAA;AACF;;AAEA;EACE,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AACF;;AACA;EACE,WAAA;EACA,YAAA;EACA;wBAAA;EAEA,WAAA;AAEF;;AAEA;EACE,qCAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;AACF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAGF;;AAAA;EACE,sBAAA;AAGF;;AAAA;EACE,WAAA;AAGF;;AAAA;EACE,0CAAA;EACA,WAAA;EACA,mBAAA;AAGF;;AAAA;EACE,WAAA;EACA,aAAA;EACA,WAAA;EACA,uHAAA;EAOA,oCAAA;AAHF;;AAMA;EACE,wBAAA;EACA,uBAAA;EACA,gBAAA;EAEA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AAJF;;AAOA;EACE,YAAA;EACA,wBAAA;AAJF;;AAOA;EACE,wBAAA;AAJF;;AAOA;EACE,wBAAA;AAJF;;AAOA;EAGM;IACE,iBAAA;IACA,WAAA;IACA,kBAAA;EANN;AACF;AAUA;EACE;IACE,gCAAA;IACA,eAAA;EARF;EAUA;IACE,8BAAA;EARF;EAUA;IACE,2BAAA;EARF;AACF;AAUA;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AARF","sourcesContent":["@use \"src/styles/variables\" as vars;\n\n.modal {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.modal-100w {\n  margin: 0 !important;\n  padding: 0 !important;\n  width: 100% !important;\n  max-width: inherit !important;\n  height: 100% !important;\n}\n\n.modal-header {\n  border-bottom: 0px !important;\n}\n.modal-dialog {\n  max-width: none;\n}\n.modal-100w .modal-content {\n  border: 0;\n  border-radius: 0;\n  min-height: -webkit-fill-available;\n  background-color: #ffffffed !important;\n}\n\n.img-wrapper {\n  height: calc(100% - 100px) !important;\n  overflow: hidden;\n  width: max-content;\n  margin: 0 10%;\n}\n.img-cont {\n  float: left;\n  margin: 15px;\n  /*height: calc(100% - 15px);\n  display: inline-grid;*/\n  width: 70vw;\n  // display: none;\n}\n\n.img-show {\n  height: calc(100% - 100px) !important;\n  overflow: hidden;\n  width: 70vw;\n  margin: 0 10%;\n  position: absolute;\n  top: 0;\n}\n.back_btn {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 26px;\n  float: left;\n  cursor: pointer;\n}\n\n.gal_title {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 46px;\n  text-align: center;\n  padding: 3% 0 0 0;\n}\n.gal_subtitle {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n}\n\n.modal-title {\n  width: 100% !important;\n}\n\n.title_ctr {\n  width: 100%;\n}\n\n.img-cont img {\n  max-height: calc(100vh - 200px) !important;\n  width: 100%;\n  border-radius: 20px;\n}\n\ninput[type=\"range\"] {\n  width: 50vw;\n  margin: 0 20%;\n  height: 2px;\n  background: linear-gradient(\n    to right,\n    rgb(185, 166, 145) 0%,\n    rgb(185, 166, 145) 50%,\n    rgb(185, 166, 145) 50%,\n    #fff 100%\n  );\n  border: solid 1px rgb(185, 166, 145);\n}\n\ninput::-webkit-slider-thumb {\n  background-color: orange;\n  border: solid 12px gold;\n  border-radius: 0;\n\n  height: 25px;\n  width: 25px;\n  border-radius: 50%;\n  -webkit-appearance: none;\n}\n\n.carousel.carousel-slider .control-arrow {\n  cursor: none;\n  display: none !important;\n}\n\n.carousel .carousel-status {\n  display: none !important;\n}\n\n.carousel .control-dots {\n  display: none !important;\n}\n\n@media screen and (vars.$mobile-media) {\n  .Modal {\n    .modal {\n      .modal-content {\n        margin-left: 20px;\n        width: 100%;\n        margin-right: 20px;\n      }\n    }\n  }\n}\n@media only screen and (max-width: 768px) {\n  .gal_title {\n    padding: 7% 10% 0 12% !important;\n    font-size: 20px;\n  }\n  .modal-header {\n    padding-bottom: 0px !important;\n  }\n  .modal-body {\n    padding-top: 0px !important;\n  }\n}\n.close_btn {\n  right: 10px;\n  position: absolute;\n  padding: 0px 10px;\n  font-size: 16px;\n  color: #7a7a7a;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
